module.exports = __webpack_public_path__ + "img/festa3.ad0baa6a.png";